import React, { Children, isValidElement, useId, useState } from 'react';
import './PropertyDetailDock.css';

export default function PropertyDetailDock({ children, language = 'en', reply, busy = false }) {
  const [collapsed, setCollapsed] = useState(true);
  const panelId = useId();
  const spanish = language === 'es';
  const title = spanish ? 'Pregunte sobre esta propiedad' : 'Ask about this home';
  const action = collapsed ? (spanish ? 'Expandir' : 'Expand') : (spanish ? 'Minimizar' : 'Minimize');
  const items = Children.toArray(children);
  const isQuestion = item => isValidElement(item) && item.type === 'form' && item.props.className?.includes('assistant-detail-question');
  const questions = items.filter(isQuestion);
  return <div className={`property-detail-dock ${collapsed ? 'property-detail-dock--collapsed' : ''}`}>
    {questions.length > 0 && <button type="button" className="property-detail-dock-toggle" aria-expanded={!collapsed} aria-controls={panelId} aria-label={`${action}: ${title}`} onClick={() => setCollapsed(value => !value)}>
      <span className="property-detail-dock-title">{title}{collapsed && (busy || reply) && <small role="status">{busy ? (spanish ? 'Pensando…' : 'Thinking…') : (spanish ? 'Respuesta lista' : 'Reply ready')}</small>}</span>
      <span className="property-detail-dock-toggle-action">{action}<svg viewBox="0 0 20 20" aria-hidden="true"><path d={collapsed ? 'M5 12l5-5 5 5' : 'M5 8l5 5 5-5'} /></svg></span>
    </button>}
    <div id={panelId} className="property-detail-dock-question-panel" hidden={collapsed}>{questions}</div>
    {items.filter(item => !isQuestion(item))}
  </div>;
}
